import { Component }      from '@angular/core';
import { BooksComponent } from './books.component';

@Component({
  selector: 'dra-bookmarked-books',
  templateUrl: 'books.component.html',
})
export class BookmarkedBooksComponent extends BooksComponent {
  public title: string = 'Bookmarked books';
  public searchParams: {
    search?: string,
    category_id?: number,
    bookmarked?: number,
    page?: number,
    per_page?: number,
    order_by?: string,
  } = {
    search: '',
    category_id: 0,
    bookmarked: 1,
    page: 1,
    per_page: 20,
    order_by: 'chapters_count'
  };
  public showSearch = {
    search: true,
    category_id: true,
    bookmarked: false,
    per_page: true,
    order_by: true,
  };
  public page = 'BookmarkedBooks';
}



// WEBPACK FOOTER //
// ./src/components/books/bookmarked-books.component.ts